<template>
  <v-data-table :headers="getHeader()" :items="dati" :options.sync="pagination" :no-data-text="''"
    :no-results-text="'Nessun dato trovato'" hide-default-footer hide-default-header mobile-breakpoint="0">

    <!-- header -->
    <template v-slot:header="{ props: { headers } }">
      <tr style="height: 40px" :style="{ 'background-color': headerColor }">
        <!-- Ciclo sulle colonne intestazione -->
        <th v-for="(item, i) in headers" :key="i" style="
            height: 40px;
            color: white;
            padding: 0px !important;
            font-size: 14px !important;
            min-width: 120px;
            max-width: 200px;
          " :style="{
    'border-right':
      i < headers.length - 1
        ? '1px solid!important'
        : '0px!important',
  }">
          <span v-text="item.Text"></span>
        </th>
      </tr>
    </template>

    <!-- items -->
    <template v-slot:item="{ item }">
      <tr v-if="dati.length == 1" style="vertical-align: middle !important">
        <!-- Ciclo sulle colonne intestazione -->
        <td v-for="(h, i) in headers" :key="i" style="height: 35px !important; padding: 5px; text-align: center">
          <span class="subheading" style="font-weight: bold !important" v-text="item[h.Text].toLocaleString() +
    (filtro == 'Fatturato' ? ' € ' : '')
    ">
          </span>
        </td>
      </tr>
      <tr v-else style="vertical-align: middle !important">
        <td v-for="(x, i) in headers" :key="i" style="height: 35px !important; padding: 5px; text-align: center" :style="[
    backgroundPeriodo(item)
      ? { 'background-color': '#f2f2f2' }
      : { 'background-color': '#cde1f4' },
  ]">
          <span class="subheading" style="font-weight: bold !important" v-text="item[x.Text].toLocaleString() +
    (filtro == 'Fatturato' ? ' € ' : '')
    "></span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    dati: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headerColor: { type: String, default: "" },

    filtro: { type: String, default: "" },
  },

  data: () => ({
    pagination: {
      page: 1,
      rowsPerPage: 100,
    },

    headers: [],
  }),

  methods: {
    getHeader() {
      let arr = [];
      // Ciclo sui dati
      this.dati.forEach(function (value) {
        // Ciclo sulle chiavi del json
        for (var key in value) {
          // Escludo le colonne nascoste (-1 sulla pivot non sono da vedere)
          if (value[key] == -1) continue;

          // Escludo le colonne che non riguardano i dati
          if (
            key == "Tipologia" ||
            key == "Filtro" ||
            key == "Anno" ||
            key == "Periodo"
          )
            continue;

          //console.log(key + " : " + value[key]);

          // Controllo se la colonna è già presente
          if (!!arr.find((f) => f.Text == key) == false) {
            arr.push({ Text: key });
          }
        }
      });

      // Memorizzo le colonne
      this.headers = arr;

      return arr;
    },

    backgroundPeriodo(item) {
      let periodo1 = true;
      if (item.Periodo == this.dati[0].Periodo) periodo1 = true;
      else periodo1 = false;
      return periodo1;
    },
  },
};
</script>